import { buildEnvConfig } from './buildEnvConfig'
import { envSchema } from './envSchema'
import pkg from '../../../package.json'

const ENVS = envSchema.parse(
  buildEnvConfig(import.meta.env as Record<string, string | undefined>)
)

export const appSettings = Object.freeze({
  ...ENVS,
  applicationName: pkg.name,
  applicationVersion: pkg.version,
  stepbarHeight: 58, // TODO deveria ser dinamico?
  chatDelay: 40000,
  algoliaLastSearchDisplayQuantity: 3,
  environment: import.meta.env.VITE_ENV || 'development'
})
